var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBadgeYears = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100%",
  viewBox: "0 0 680 680",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "coinBody",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F5D97E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "35%",
  stopColor: "#E8C44A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "65%",
  stopColor: "#C9A020"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A07818"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "outerRim",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F7E8A0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "30%",
  stopColor: "#D4A825"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "70%",
  stopColor: "#8E6510"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#6B4C0C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "innerRim",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F9EEBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "40%",
  stopColor: "#DEBB50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#9A7518"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "innerDisc",
  x1: 0,
  y1: 0,
  x2: 0.8,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#EED870"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#D4AD30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#B08A1A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "letterGrad",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F5E4A0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "30%",
  stopColor: "#D4AB30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "70%",
  stopColor: "#8E6818"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#6B4E10"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "innerClip"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 210
})))), /*#__PURE__*/React.createElement("circle", {
  cx: 344,
  cy: 344,
  r: 295,
  fill: "#4A3008",
  opacity: 0.35,
  style: {
    fill: "rgb(74, 48, 8)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.35,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 295,
  fill: "url(#outerRim)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 295,
  fill: "none",
  stroke: "#F7E8A0",
  strokeWidth: 3,
  opacity: 0.4,
  style: {
    fill: "none",
    stroke: "rgb(247, 232, 160)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 3,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.4,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 285,
  fill: "none",
  stroke: "#6B4C0C",
  strokeWidth: 1.5,
  opacity: 0.5,
  style: {
    fill: "none",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "1.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 268,
  fill: "url(#coinBody)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 268,
  fill: "none",
  stroke: "#8E6510",
  strokeWidth: 2,
  style: {
    fill: "none",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 240,
  fill: "none",
  stroke: "#7A5A10",
  strokeWidth: 4,
  style: {
    fill: "none",
    stroke: "rgb(122, 90, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 237,
  fill: "none",
  stroke: "#F5D97E",
  strokeWidth: 1,
  opacity: 0.5,
  style: {
    fill: "none",
    stroke: "rgb(245, 217, 126)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 220,
  fill: "url(#innerDisc)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 220,
  fill: "none",
  stroke: "#7A5A10",
  strokeWidth: 2.5,
  style: {
    fill: "none",
    stroke: "rgb(122, 90, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "2.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#innerClip)",
  opacity: 0.22,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.22,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("line", {
  x1: 160,
  y1: 120,
  x2: 160,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 175,
  y1: 120,
  x2: 175,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 190,
  y1: 120,
  x2: 190,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 205,
  y1: 120,
  x2: 205,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 220,
  y1: 120,
  x2: 220,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 235,
  y1: 120,
  x2: 235,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 250,
  y1: 120,
  x2: 250,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 265,
  y1: 120,
  x2: 265,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 120,
  x2: 280,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 295,
  y1: 120,
  x2: 295,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 310,
  y1: 120,
  x2: 310,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 325,
  y1: 120,
  x2: 325,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 120,
  x2: 340,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 355,
  y1: 120,
  x2: 355,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 370,
  y1: 120,
  x2: 370,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 385,
  y1: 120,
  x2: 385,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 400,
  y1: 120,
  x2: 400,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 415,
  y1: 120,
  x2: 415,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 430,
  y1: 120,
  x2: 430,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 445,
  y1: 120,
  x2: 445,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 460,
  y1: 120,
  x2: 460,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 475,
  y1: 120,
  x2: 475,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 490,
  y1: 120,
  x2: 490,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 505,
  y1: 120,
  x2: 505,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 520,
  y1: 120,
  x2: 520,
  y2: 560,
  stroke: "#6B4C0C",
  strokeWidth: 4,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(107, 76, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("rect", {
  x: 310,
  y: 200,
  width: 60,
  height: 280,
  rx: 2,
  fill: "url(#letterGrad)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 310,
  y: 200,
  width: 4,
  height: 280,
  rx: 1,
  fill: "#F5E4A0",
  opacity: 0.5,
  style: {
    fill: "rgb(245, 228, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 366,
  y: 200,
  width: 4,
  height: 280,
  rx: 1,
  fill: "#5A420C",
  opacity: 0.4,
  style: {
    fill: "rgb(90, 66, 12)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.4,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 278,
  y: 195,
  width: 124,
  height: 30,
  rx: 3,
  fill: "url(#letterGrad)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 278,
  y: 195,
  width: 124,
  height: 3,
  rx: 1,
  fill: "#F5E4A0",
  opacity: 0.5,
  style: {
    fill: "rgb(245, 228, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 278,
  y: 222,
  width: 124,
  height: 3,
  rx: 1,
  fill: "#5A420C",
  opacity: 0.35,
  style: {
    fill: "rgb(90, 66, 12)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.35,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 278,
  y: 225,
  width: 32,
  height: 18,
  rx: 2,
  fill: "url(#letterGrad)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 370,
  y: 225,
  width: 32,
  height: 18,
  rx: 2,
  fill: "url(#letterGrad)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 278,
  y: 455,
  width: 124,
  height: 30,
  rx: 3,
  fill: "url(#letterGrad)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 278,
  y: 455,
  width: 124,
  height: 3,
  rx: 1,
  fill: "#F5E4A0",
  opacity: 0.5,
  style: {
    fill: "rgb(245, 228, 160)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 278,
  y: 482,
  width: 124,
  height: 3,
  rx: 1,
  fill: "#5A420C",
  opacity: 0.35,
  style: {
    fill: "rgb(90, 66, 12)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.35,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 278,
  y: 437,
  width: 32,
  height: 18,
  rx: 2,
  fill: "url(#letterGrad)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 370,
  y: 437,
  width: 32,
  height: 18,
  rx: 2,
  fill: "url(#letterGrad)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M170 200 A200 200 0 0 1 340 140",
  fill: "none",
  stroke: "#F9EEBC",
  strokeWidth: 2,
  opacity: 0.2,
  style: {
    fill: "none",
    stroke: "rgb(249, 238, 188)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.2,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 300,
  cy: 170,
  rx: 100,
  ry: 20,
  fill: "#F9EEBC",
  opacity: 0.1,
  style: {
    fill: "rgb(249, 238, 188)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBadgeYears);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/badgeYears.3334ab9911bfc02eee1cb81e3a0d81c2.svg";